import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import GuidanceWrapper from "Projects/routes/GuidanceWrapper";
import { routes } from "Projects/config/routes";
import Invite from "Projects/routes/Setup/routes/Invite";
import GuidingQuestions from "Projects/routes/Setup/routes/GuidingQuestions";
import ReportTemplate from "Projects/routes/Setup/routes/ReportTemplate";
import Introduction from "Projects/routes/Setup/routes/Introduction";
import Configurations from "Projects/routes/Setup/routes/ProjectConfigurations";
const {
  setup: { path },
} = routes;
const SetupRoute = store => {
  return {
    path,
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "project-group" */ "./Setup"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      ReportTemplate(store),
      Invite(store),
      GuidanceWrapper(store),
      Introduction(store),
      GuidingQuestions(store),
      Configurations(store),
    ],
  };
};
export default SetupRoute;
